import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { NavComponent } from './components/nav/nav.component';
import { HomeComponent } from './components/home/home.component';
import { AgenciesComponent } from './components/agencies/agencies.component';
import { AgencyComponent } from './components/agency/agency.component';
import { ContactComponent } from './components/contact/contact.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FooterComponent } from './components/footer/footer.component';
import { MapComponent } from './components/map/map.component';

import { FirebaseService } from "./services/firebase/firebase.service";
import { ApiClientsService } from "./services/api-clients/api-clients.service";
import { EventsService } from "./services/events/events.service";
import { GoogleService } from "./services/google/google.service";

import { AppRoutingModule } from './app-routing.module';

@NgModule({
    declarations: [
        AppComponent,
        NavComponent,
        HomeComponent,
        AgenciesComponent,
        AgencyComponent,
        ContactComponent,
        NotFoundComponent,
        FooterComponent,
        MapComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'sinirji911-live' }),
        AppRoutingModule
    ],
    providers: [FirebaseService, ApiClientsService, EventsService, GoogleService],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts